<template>
  <div v-if="readonly">
    <v-icon>mdi-clock-outline</v-icon>{{value.from}} - {{value.to}}

  </div>
  <v-menu
    v-else
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="timeSpan"
        prepend-icon="mdi-clock-outline"
        readonly
        v-on="on"
        clearable
      />
    </template>
    <div v-if="menu" style="background-color: white; padding: 5px;">
      <v-row justify="space-around" align="center">
        <v-col style="width: 290px; flex: 0 1 auto;">
          <h2>Von:</h2>
          <v-time-picker v-model="from" :max="value.to" format="24hr" />
        </v-col>
        <v-col style="width: 290px; flex: 0 1 auto;">
          <h2>Bis:</h2>
          <v-time-picker v-model="to" :min="value.from" format="24hr" @click:minute="menu = false" />
        </v-col>
      </v-row>
    </div>
  </v-menu>
</template>

<script>

export default {
  name: 'HourRange',
  props: {
    value: {
    },
    readonly: {
      type: Boolean,
    },
  },
  components: {
  },
  watch: {
    menu(newValue) {
      if(!newValue) {
        if (!this.value.from || !this.value.to) {
          this.$emit('input', {from: null, to: null});
        }
      }
    },
  },
  mounted() {
  },
  computed: {
    from: {
      get() {
        return this.value.from;
      },
      set(value) {
        this.$emit('input', {from: value, to: this.value.to});
      }
    },
    to: {
      get() {
        return this.value.to;
      },
      set(value) {
        this.$emit('input', {from: this.value.from, to: value});
      }
    },
    timeSpan: {
      get() {
        if (!this.value.from || !this.value.to) {
          return '';
        }

        return `${this.value.from}-${this.value.to}`;
      },
      set(value) {
        if (!value) {
          this.$emit('input', {from: null, to: null, breaks: []});
        }
      },
    },
  },
  methods: {
  },
  data() {
    return {
      menu: false,
    };
  },
};
</script>
